/**
 * mojeID OIDC login — redirect-based flow.
 *
 * Unlike Google (popup) and Facebook (SDK), mojeID uses a standard authorization
 * code flow. We POST to the allauth redirect endpoint, which responds with HTTP 302
 * to mojeid.cz. The browser follows the chain:
 *   POST /_allauth/.../provider/redirect → 302 → mojeid.cz/oidc/authorization
 *   → user authenticates → mojeid.cz → 302 → /_allauth/.../provider/callback
 *   → allauth processes → redirect to callback_url
 *
 * A hidden form submit is used so the browser handles the 302 natively
 * (XHR/fetch cannot follow cross-origin redirects without CORS issues).
 * CSRF token is included via the standard Django double-submit cookie pattern.
 */
import { csrfToken } from "@/mk/common/csrfToken";

const ALLAUTH_PROVIDER_REDIRECT = "/_allauth/browser/v1/auth/provider/redirect";

export function redirectToMojeID(callbackUrl: string): void {
    const form = document.createElement("form");
    form.method = "POST";
    form.action = ALLAUTH_PROVIDER_REDIRECT;
    form.style.display = "none";

    const fields: Record<string, string> = {
        provider: "mojeid",
        process: "login",
        callback_url: callbackUrl || "/",
        csrfmiddlewaretoken: csrfToken() || "",
    };

    for (const [name, value] of Object.entries(fields)) {
        const input = document.createElement("input");
        input.type = "hidden";
        input.name = name;
        input.value = value;
        form.appendChild(input);
    }

    document.body.appendChild(form);
    form.submit();
}
